module.exports = __webpack_public_path__ + "static/icon-dbbc80fc54ae383cd4403a02cae00830.png";